import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ProductoRestriccionOficina} from '../_models/producto-restriccion-oficina';
import {ProductoMonto} from '../_models/producto-monto';

@Injectable({
  providedIn: 'root'
})
export class ProductoRestriccionOficinaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosRestriccionesOficinas';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoRestriccionOficina[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoRestriccionOficina[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoRestriccionOficina[] ) );
  }

  listadoPorAgrupacion( idAgrupacion: string ) {
    return this.httClient.get( this.rutServicio + '/agrupacionEstructuraFisica/' + idAgrupacion ).pipe( map( res => res as ProductoRestriccionOficina[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoRestriccionOficina ) );
  }

  crear( regCrear: ProductoRestriccionOficina ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoRestriccionOficina ) );
  }

  actualizar( regActualizar: ProductoRestriccionOficina ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoRestriccionOficina[] ) {
    regActualizar.map( ( s: ProductoRestriccionOficina ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk' , regActualizar ).pipe( map( res => res as any ) );
  }

}
